"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalytics = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _analytics = require("../../../analytics");
var _getSiteType = require("../../../utils/getSiteType");
var _throttleDebounce = require("throttle-debounce");
var _selectors = require("../../../selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Функции аналитики, требующие декорации, созданы в useCallback для оптимизации
 * */
const useAnalytics = isMyHome => {
  const deviceType = (0, _reactRedux.useSelector)(_selectors.selectDeviceType);

  /** Функции аналитики отличаеются для моего дома */
  const submitAnalyticsChange = isMyHome ? () => {} : _analytics.trackAddressChange; //  Для моего дома функция аналитики отсвутствует
  const submitAnalyticsPick = isMyHome ? _analytics.prepareTrackMyHomeAddressPick : _analytics.prepareTrackAddressPick;
  const pageType = isMyHome ? 'MyHomeMainPage' : 'EstateCalculator';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const trackAddressPick = React.useCallback(submitAnalyticsPick({
    pageType,
    siteType: (0, _getSiteType.getSiteType)(deviceType)
  }), [deviceType]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const trackAddressChangeThrottled = React.useCallback((0, _throttleDebounce.throttle)(400, submitAnalyticsChange), []);
  return {
    trackAddressChangeThrottled,
    trackAddressPick
  };
};
exports.useAnalytics = useAnalytics;